import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { forwardRef } from 'react';
import styles from '../../components/base/HorizonInput/index.module.scss.js';
import classNames from './../../external_lib/classnames/index.js';
import Cancel from '../../assets/icons/jsx/Cancel.js';
import AntInput from './../../external_lib/antd/es/input/index.js';
var HorizonInput = forwardRef(function (_a, ref) {
  var _b = _a.allowClear,
    allowClear = _b === void 0 ? false : _b,
    className = _a.className,
    restProps = __rest(_a, ["allowClear", "className"]);
  return React__default.createElement(AntInput, __assign({
    allowClear: allowClear && {
      clearIcon: React__default.createElement(Cancel, null)
    },
    className: classNames(styles.horizonInput, className),
    ref: ref
  }, restProps));
});
export { HorizonInput as default };
//# sourceMappingURL=index.js.map
